import isNil from 'lodash/isNil';
import startCase from 'lodash/startCase';
import {
  PCCDashboardProgramStatus,
} from 'dtos/pCCDashboardProgramStatus';

export type PCCStatusPresentation = {
  dotClassName: string;
  label: string;
  pillClassName: string;
};

const OPTED_OUT_STATUS_PRESENTATION: PCCStatusPresentation = {
  dotClassName: 'bg-slate-400',
  label: 'Opted Out',
  pillClassName: 'bg-slate-100 text-slate-600',
};

const DEFAULT_STATUS_PRESENTATION: PCCStatusPresentation = {
  dotClassName: 'bg-slate-400',
  label: '',
  pillClassName: 'bg-slate-100 text-slate-600',
};

const NEUTRAL_STATUS_PRESENTATION: Omit<PCCStatusPresentation, 'label'> = {
  dotClassName: 'bg-gray-400',
  pillClassName: 'bg-gray-100 text-gray-600',
};

const WARNING_STATUS_PRESENTATION: Omit<PCCStatusPresentation, 'label'> = {
  dotClassName: 'bg-amber-400',
  pillClassName: 'bg-amber-100 text-amber-800',
};

const GREEN_STATUS_PRESENTATION: Omit<PCCStatusPresentation, 'label'> = {
  dotClassName: '!hidden',
  pillClassName: 'bg-emerald-100 text-emerald-700',
};

const STATUS_PRESENTATION: Record<
  PCCDashboardProgramStatus,
  Omit<PCCStatusPresentation, 'label'>
> = {
  [PCCDashboardProgramStatus.NotEligible]: NEUTRAL_STATUS_PRESENTATION,
  [PCCDashboardProgramStatus.Eligible]: GREEN_STATUS_PRESENTATION,
  [PCCDashboardProgramStatus.Enrolled]: GREEN_STATUS_PRESENTATION,
  [PCCDashboardProgramStatus.Completed20Minutes]: GREEN_STATUS_PRESENTATION,
  [PCCDashboardProgramStatus.MinutesRemaining]: WARNING_STATUS_PRESENTATION,
  [PCCDashboardProgramStatus.Pending]: WARNING_STATUS_PRESENTATION,
  [PCCDashboardProgramStatus.PendingDay1]: WARNING_STATUS_PRESENTATION,
  [PCCDashboardProgramStatus.PendingDay2]: WARNING_STATUS_PRESENTATION,
  [PCCDashboardProgramStatus.Complete]: GREEN_STATUS_PRESENTATION,
};

export function getPCCStatusPresentation(
  status?: PCCDashboardProgramStatus,
  isOptedOut = false,
): PCCStatusPresentation {
  if (isOptedOut) {
    return OPTED_OUT_STATUS_PRESENTATION;
  }

  if (isNil(status)) {
    return DEFAULT_STATUS_PRESENTATION;
  }

  const presentation = STATUS_PRESENTATION[status] ?? DEFAULT_STATUS_PRESENTATION;

  return {
    ...presentation,
    label: startCase(status),
  };
}
